import type { ComponentType, SVGProps } from 'react';

import { List, LogOut, Star, User } from 'lucide-react';

import { getCurrentLocaleCode } from '@crm/shared/lib';
import { ROUTES } from '@crm/shared/routes';
import { getTariffsUrl } from '@entities/tariff';

type TProfileMenuItem = {
    id: number;
    textKey: string;
    icon: ComponentType<SVGProps<SVGSVGElement>> | null;
    route?: typeof ROUTES.PROFILE | typeof ROUTES.ORDERS;
    href?: string;
    openInNewTab?: boolean;
    separatorAfter?: boolean;
};

export const profileData: TProfileMenuItem[] = [
    {
        id: 2,
        textKey: 'crm.userProfileMenu.items.profile',
        icon: User,
        route: ROUTES.PROFILE,
    },
    {
        id: 3,
        textKey: 'crm.userProfileMenu.items.orders',
        icon: List,
        route: ROUTES.ORDERS,
    },
    {
        id: 4,
        textKey: 'crm.userProfileMenu.items.tariffs',
        icon: Star,
        href: getTariffsUrl(getCurrentLocaleCode()),
        openInNewTab: true,
        separatorAfter: true,
    },
    // {
    //     id: 5,
    //     textKey: 'crm.userProfileMenu.items.users',
    //     icon: Users,
    // },
    {
        id: 6,
        textKey: 'crm.userProfileMenu.items.logout',
        icon: LogOut,
        href: '/logout',
    },
];
